export const nodeTypeEnum = {
  OFFICE: 1,
  DEVICE: 2
};

export const nodeTypeList = {
  1: { nodeType: 1, name: '机构' },
  2: { nodeType: 2, name: '设备' }
};
